<template>
  <svg enable-background="new 0 0 512 512" height="100%" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
    <g id="Layer_2_00000152957415712910178480000005535372858609875887_">
      <g id="_03.user">
        <path
          d="m335.6 305.1h-159.2c-81.5 0-147.5 66-147.5 147.5 0 32.8 26.6 59.4 59.4 59.4h335.4c32.8 0 59.4-26.6 59.4-59.4 0-81.5-66-147.5-147.5-147.5z"
        ></path>
        <circle cx="256" cy="131.5" r="131.5"></circle>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  name: "M4UserSvg"
};
</script>
